
<div class="d-flex flex-row align-items-center">
  <!-- class="customPageContainer h-auto" -->
  <c-container class="customPageContainer" fluid>
    <!-- <app-pipeline-dashboard #pipeDash></app-pipeline-dashboard> -->
    <router-outlet></router-outlet>
  </c-container>
</div>

<c-modal
  alignment="center"
  backdrop="static"
  id="apiErrorModal"
  [keyboard]="false"
  [visible]="(apiError | async) !== null"
>
  <c-modal-header>
    <h5 cModalTitle>Pipeline Dashboard Unavailable</h5>
  </c-modal-header>
  <c-modal-body *ngIf="apiError | async as error">
    <p>The Pipeline Dashboard could not be loaded.</p>
    <p>The service may be temporarily unavailable.</p>
    <!-- <small *ngIf="error.status">Error code: {{ error.status }}</small> -->
  </c-modal-body>
  <c-modal-footer>
    <button cButton color="primary" type="button" (click)="dismissApiError()">OK</button>
  </c-modal-footer>
</c-modal>